import { Colors } from "./Colors";

export const Styles = {
  BOX_SHADOW: `box-shadow: 0px 1px 4px ${Colors.BLACK.string()};`,
  BOX_SHADOW_STRONG: "box-shadow: 0px 1px 4px;",
};
